import { createContext, memo, type ReactNode, useContext, useMemo } from 'react';

const PlanRevampContext = createContext(false);

export const usePlanPageRevampContext = () => useContext(PlanRevampContext);

interface ProviderProperties {
  children: ReactNode;
}

/** Marks org-chart subtree as revamp so shared DesktopPanel children pick up revamp styling. */
export const PlanRevampProvider = memo(({ children }: ProviderProperties) => {
  const value = useMemo(() => true, []);
  return <PlanRevampContext.Provider value={value}>{children}</PlanRevampContext.Provider>;
});

PlanRevampProvider.displayName = 'PlanRevampProvider';
